import {CompositeStateType} from "contracts/holotrak/compositeState";
import {jsonMember, jsonObject, TypedJSON} from "typedjson";


/*
    {
        "name": "altitude",
        "dataType": "number",
        "description": "",
        "attributeTags": {
            "average": "200",
            "max": "400",
            "min": "332"
        }
    }
*/

function getStandardParser(defaultValue: number) {
    return function standardAttributeConfigValueDeserializer(value: unknown): number {
        try {
            return value ? parseFloat(value as string) : defaultValue;
        } catch (e) {
            return defaultValue;
        }
    }
}

@jsonObject()
export class DeviceAttributeTags {
    @jsonMember(Number, {
        deserializer: getStandardParser(20)
    })
    avg: number;

    @jsonMember(Number, {
        deserializer: getStandardParser(100)
    })
    max: number

    @jsonMember(Number, {
        deserializer: getStandardParser(0)
    })
    min: number

    @jsonMember(String)
    unit: string;

    @jsonMember(Boolean, {
        deserializer: (value) => {
            return (value ? value === 'true' : true);
        }
    })
    is_displayed: boolean;

    constructor() {
        this.avg = 0;
        this.max = 100;
        this.min = 0;
        this.unit = '';
        this.is_displayed = true;
    }
}

@jsonObject()
export class DeviceAttribute {
    @jsonMember(() => String)
    name: CompositeStateType;

    @jsonMember(String)
    dataType: string;

    @jsonMember(String)
    description: string;

    @jsonMember(String)
    value: string;

    @jsonMember(DeviceAttributeTags, {
        deserializer: (value) => {
            return DeviceAttributeTagsSerializer.parse(value);
        }
    })
    attributeTags: DeviceAttributeTags;

    constructor() {
        this.name = '' as CompositeStateType;
        this.dataType = '';
        this.description = '';
        this.value = '';
        this.attributeTags = new DeviceAttributeTags();
    }

    getUnit() {
        return this.attributeTags.unit;
    }
}


@jsonObject
export class DeviceTag {
    @jsonMember(String)
    key: string
    @jsonMember(String)
    value: string
}

export const DeviceTagSerializer = new TypedJSON(DeviceTag);
export const DeviceAttributeSerializer = new TypedJSON(DeviceAttribute);
export const DeviceAttributeTagsSerializer = new TypedJSON(DeviceAttributeTags);


export function getTagNameFromKey(key: string): string {
    switch (key) {
        default:
            return key
                .replace(/[_\-.]/g, ' ')
                .replace(/\b\w/g, char => char.toUpperCase())
                .trim();
    }
}
